export const LAUNCH_DARKLY_ANONYMOUS_EMAIL = 'anonymous@hqo.co';
export const BUILDING = 'BUILDING';
// Update VERTICAL_NAME to the new vertical name
export const VERTICAL_NAME = 'HELLO-REACT';
